import {CONTACT_ACTION_IDS, useAvailableActions} from '@adv-mt/mt-form-contact-seller'

import BannerInfo from '../panels/contact/BannerInfo.js'
import ContactPanel, {getShowCanariasBanner} from '../panels/contact/index.js'

const useContactCardProps = ({
  ad = {},
  alertSearch,
  buyerIntentions,
  config,
  formPresentation,
  handlers,
  isContactFormOpen,
  isFormInDrawer,
  isMobile,
  isNewVehicle,
  isRenting,
  isVOorVNorKM0,
  leadData,
  multiProvinceTrackingData,
  onContactFormOpenChange,
  onOpenDrawer,
  onShowAllRatings,
  onStickyBarOpenDrawer,
  onTargetBuyerChange,
  pageName,
  presetBuyerIntentions,
  presetMessage,
  seller = {},
  showTargetBuyerOptions,
  subscriptionCommitment,
  targetBuyer,
  trackAlertCreated,
  trackSendMessageClick,
  user
}) => {
  const {AUTHENTICATION_HIT_INFORMATIONS_2} = config.get('tracking')
  const {ZIPCODE_ENABLED} = config.get('form')

  const sellerPhone = seller.isPrivate ? seller.user?.phone : seller.dealer?.phoneNumber
  const sellerDisplayName = seller.isPrivate ? seller.user?.name : seller.dealer?.name
  const sellerId = seller?.isDealer ? seller.dealer.sellerMessagingId : seller?.user.userId
  const sellerLogo = seller.dealer?.showContactLogo ? seller.dealer?.logoImageUrl : undefined
  const sellerPhoto = seller.isPrivate ? seller.user?.avatar : undefined
  const sellerLocation = seller.isPrivate ? seller.user?.province : seller.dealer?.location?.province
  const sellerRatingAverage = seller.dealer?.ratings?.average
  const sellerRatingCount = seller.dealer?.ratings?.totalReviews

  const availableActions = useAvailableActions({
    contractId: seller.contractId,
    hasWhatsapp: isMobile,
    hasWhatsappProduct: seller.dealer?.hasWhatsappProduct ?? false,
    hidePhone: ad.hidePhone
  })
  const cardAvailableActions = {
    ...availableActions,
    [CONTACT_ACTION_IDS.WHATSAPP]: {available: false}
  }

  const cardProps = {
    adId: ad.id,
    alertSearch,
    authenticationHitInformation2: AUTHENTICATION_HIT_INFORMATIONS_2.DETAIL,
    availableActions: cardAvailableActions,
    buyerIntentions,
    canariasBanner: <ContactPanel ad={ad} seller={seller} />,
    contractId: seller.contractId,
    enableAlertCreation: true,
    enableAuthBeforeLead: Boolean(seller?.isDealer),
    extendedLeadTrackingData: leadData,
    formPresentation,
    hasCriteoEvents: true,
    hidePhone: ad.hidePhone,
    isDrawerOpen: isFormInDrawer ? isContactFormOpen : undefined,
    isLeadEnrichmentEnabled: config.get('LEAD_ENRICHMENT_ENABLED') && isVOorVNorKM0,
    isRenting,
    isSellerBlocked: seller.isSellerBlocked || false,
    isVOorVNorKM0,
    isZipCodeEnabled: ZIPCODE_ENABLED && isNewVehicle,
    location: sellerLocation,
    multiprovince: multiProvinceTrackingData,
    onAlertCreated: trackAlertCreated,
    onContact: handlers.onContact,
    onDrawerOpenChange: isFormInDrawer ? onContactFormOpenChange : undefined,
    onLeadError: handlers.handleLeadError,
    onLeadPhoneCall: handlers.onPhoneLead,
    onOpenDrawer,
    onSendMessageClick: trackSendMessageClick,
    onShowAllRatings,
    onSubmitError: handlers.handleSubmitError,
    onTargetBuyerChange,
    onWhatsappError: handlers.handleWhatsappError,
    pageName,
    phone: sellerPhone,
    presetBuyerIntentions,
    presetMessage,
    ratingAverage: sellerRatingAverage,
    ratingCount: sellerRatingCount,
    sellerId,
    sellerLogo,
    sellerName: sellerDisplayName,
    sellerPhoto,
    showTargetBuyerOptions,
    subscriptionCommitment,
    targetBuyer,
    underlineRevealedPhone: true,
    userData: user
  }

  const stickyProps = {
    adId: ad.id,
    authenticationHitInformation2: AUTHENTICATION_HIT_INFORMATIONS_2.DETAIL,
    availableActions,
    canariasBanner: getShowCanariasBanner({ad, config, seller}) ? <BannerInfo /> : undefined,
    contractId: seller.contractId,
    extendedLeadTrackingData: leadData,
    hasCriteoEvents: true,
    hidePhone: ad.hidePhone,
    isSticky: true,
    multiprovince: multiProvinceTrackingData,
    onContact: handlers.onContact,
    onLeadPhoneCall: handlers.onPhoneLead,
    onSendMessageClick: trackSendMessageClick,
    onWhatsappError: handlers.handleWhatsappError,
    phone: sellerPhone,
    underlineRevealedPhone: true,
    ...(isFormInDrawer && {
      isDrawerOpen: isContactFormOpen,
      onOpenDrawer: onStickyBarOpenDrawer
    })
  }

  const galleryProps = {
    hidePhone: ad.hidePhone,
    phone: sellerPhone
  }

  return {cardProps, galleryProps, stickyProps}
}

export default useContactCardProps
